(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("babylonjs-viewer", [], factory);
	else if(typeof exports === 'object')
		exports["babylonjs-viewer"] = factory();
	else
		root["BabylonViewer"] = factory();
})((typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : this), () => {
return 